import Constant from "../constants";
import Cookies from "js-cookie";
import * as User from "./user.ts";
import * as Site from "./site.ts";
import * as Location from "./location";
import * as StatusManagement from "./statusmanagement";
import * as CustomField from "./customField";

async function futch(url, opts = {}, onProgress) {
  console.log(url, opts);
  return new Promise((res, rej) => {
    var xhr = new XMLHttpRequest();
    xhr.open(opts.method || "get", url);
    for (var k in opts.headers || {}) xhr.setRequestHeader(k, opts.headers[k]);
    xhr.onload = (e) => res(e.target);
    xhr.onerror = rej;
    if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress; // event.loaded / event.total * 100 ; //event.lengthComputable
    xhr.send(opts.body);
  });
}

async function fetchAPI({
  method,
  uri,
  body,
  success,
  error,
  serviceBaseUrl,
  useRefreshToken = false,
}) {
  let headers = {
    Accept: "*/*",
    "Access-Control-Allow-Origin": "*",
  };
  if (body instanceof FormData) {
    headers = {};
  } else {
    headers["Content-Type"] = "application/json";
  }

  if (!method) {
    method = "get";
  }
  // Build complete API url
  // If service URL is specified, use it, otherwise use default API url
  let apiUrl = "";
  if (serviceBaseUrl) {
    apiUrl = serviceBaseUrl + uri;
  } else {
    apiUrl = Constant.apiBaseUrl + uri;
  }

  // console.log("Calling api " + apiUrl);

  // Get access token and attach it to API request's header
  let access_token = Cookies.get("access_token");
  if (access_token != null) {
    if (useRefreshToken == true) {
      access_token = Cookies.get("refresh_token");
    }
    headers["Authorization"] = `Bearer ${access_token}`;
  } else {
    console.log("No token is stored");
  }

  // Construct fetch options
  let fetchOptions = { method, headers };

  console.log(fetchOptions);

  // Only add fetch body when method is PUT or POST
  if (
    method.toLowerCase() === "post" ||
    method.toLowerCase() === "put" ||
    method.toLowerCase() === "delete"
  ) {
    if (body instanceof FormData) {
      fetchOptions.body = body;
    } else {
      if (body) {
        fetchOptions.body = JSON.stringify(body);
      }
    }
  }
  // Run the fetching
  return fetch(apiUrl, fetchOptions)
    .then((responseJson) => responseJson.json())
    .then((response) => success(response))
    .catch((errorMessage) => {
      if (errorMessage) {
        if (error) {
          error(errorMessage);
        }
      } else {
        console.error(errorMessage);
      }
    });
}

function getUser() {
  const user = Cookies.get("access_token");
  return user;
}

function getCurrentAuthorId() {
  const user = Cookies.get("author_id");
  return user;
}

function getCurrentUserId() {
  const user = Cookies.get("user_id");
  return user;
}

function getCurrentUserPermission() {
  let currentUserPermissions = [];
  const currentUserId = getCurrentUserId();
  const currentAuthorId = getCurrentAuthorId();
  fetchAPI({
    method: "get",
    uri: `permission/getAllPermission.php?author_id=${currentUserId}`,
    success: (response) => {
      currentUserPermissions = response;
    },
  });
  return {
    author_id: currentAuthorId,
    user_id: currentUserId,
    permissions: currentUserPermissions,
  };
}

export default {
  fetchAPI: fetchAPI,
  futch: futch,
  getUser: getUser,
  getCurrentAuthorId,
  getCurrentUserId,
  getCurrentUserPermission,
  ...User,
  ...Site,
  ...Location,
  ...StatusManagement,
  ...CustomField,
};
